import { ModuleFE_Organization } from './ModuleFE_Organization.js';
export const ModulePackFE_OrganizationModule = [ModuleFE_Organization];
//# sourceMappingURL=module-pack.js.map